module.exports = __webpack_public_path__ + "img/logoloadbg1.ea2b0213.jpg";